// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"classrooms_maxWidth__XHdv2","pageTitle":"classrooms_pageTitle__9qNxI"};